import { useState } from "react";
import { FormGroup, Input, Label } from "reactstrap";

// Componentes
import LoginPreview from "./LoginPreview";
import EventsListPreview from "./EventsListPreview";

// Estilos
import "./appPreview.css";

const SCREENS = [
  { value: "login", label: "Login" },
  { value: "events", label: "Lista de Eventos" },
];

/**
 * Coluna de preview dos modais de build config: o seletor no topo troca a tela
 * exibida dentro da mesma moldura, começando pela de login.
 */
export default function AppPreview({
  primaryColor,
  secondaryColor,
  changeColorsLogin,
  loginTopColor,
  loginBottomColor,
  loginCopyrightColor,
  loginLogoUrl,
  loginBackgroundUrl,
  eventsListLogoUrl,
  eventsListBackgroundColor,
  eventsListTextColor,
  eventsListDateColor,
  hasFirstAccess,
}) {
  // tela exibida na moldura
  const [screen, setScreen] = useState("login");

  return (
    <div className="app-preview">
      <div className="app-preview__switch">
        {SCREENS.map(({ value, label }) => (
          <FormGroup check inline key={value}>
            <Input
              type="radio"
              id={`appPreview${value}`}
              name="appPreviewScreen"
              checked={screen === value}
              onChange={() => setScreen(value)}
            />
            <Label check for={`appPreview${value}`}>
              {label}
            </Label>
          </FormGroup>
        ))}
      </div>

      <div className="app-preview__stage">
        {screen === "login" ? (
          <LoginPreview
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
            changeColorsLogin={changeColorsLogin}
            loginTopColor={loginTopColor}
            loginBottomColor={loginBottomColor}
            loginCopyrightColor={loginCopyrightColor}
            logoUrl={loginLogoUrl}
            backgroundUrl={loginBackgroundUrl}
            hasFirstAccess={hasFirstAccess}
          />
        ) : (
          <EventsListPreview
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
            logoUrl={eventsListLogoUrl}
            backgroundColor={eventsListBackgroundColor}
            textColor={eventsListTextColor}
            dateColor={eventsListDateColor}
          />
        )}
      </div>
    </div>
  );
}
